import { createSelector } from "reselect";
import { getPageContent } from "shared/selectors/base";

// eslint-disable-next-line import/prefer-default-export
export const getWebhooks = createSelector(
  [getPageContent],
  pageContent => pageContent.webhooks
);
